import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const search = styled.div`
    flex: none;
    padding: 0 var(--space-xl) var(--space-lg);
`;

export const list = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${dFlexColumn};
    gap: var(--space-lg);
    padding: var(--space-lg);
`;

export const info = styled.div`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1.57;
    white-space: pre-line;
`;

export const item = styled.div`
    ${dFlexColumn};
    gap: var(--space-xs);
`;

export const itemTitle = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
`;

export const itemValue = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1.57;
    white-space: pre-line;
`;
